import { LOGOUT_REQUEST, LOGIN_SUCCESS } from '../actions/actions'
import { storeLocally, readLocally } from '../helpers/utility'

//check if user was authenticated form previous session, if so log them in
export function autoLogin(store) {
  try {
    const prevAuth = readLocally('fpAuth')

    const { userType, token, userId, firstName, lastName } =
      prevAuth && JSON.parse(prevAuth)

    if (userType && token) {
      store.dispatch({
        type: LOGIN_SUCCESS,
        userType,
        token,
        userId,
        firstName,
        lastName,
      })
    }
  } catch (error) {
    //no op
  }
}

// make sure logout in one tab affects other tabs too
// (when user opens the website in 2 tabs simultaneously)
export function listenForAuthChangesInAllTabs(store) {
  window.addEventListener('storage', function(e) {
    if (e.key !== 'fpAuth') return

    // user logged out
    if (e.oldValue && e.newValue === null) {
      store.dispatch({ type: LOGOUT_REQUEST })
      return
    }

    // user logged in
    if (e.newValue && e.oldValue === null) {
      storeLocally('fpAuth', e.newValue)
      autoLogin(store)
      return
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/util.js